import { render, staticRenderFns } from "./photoSelecter.vue?vue&type=template&id=47bffce1&scoped=true"
import script from "./photoSelecter.vue?vue&type=script&lang=js"
export * from "./photoSelecter.vue?vue&type=script&lang=js"
import style0 from "./photoSelecter.vue?vue&type=style&index=0&id=47bffce1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bffce1",
  null
  
)

export default component.exports